var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-in"}},[_c('div',{staticClass:"message-limit"},[_vm._v(_vm._s(_vm.getSettings.translations.limit_exceeded))])])
}
var staticRenderFns = []

export { render, staticRenderFns }